import { createSelector } from 'reselect';
import getUserSelector from './getUserSelector';

import { EMPTY_ARRAY } from '/business/shared/state/selectors/util';

export default createSelector([getUserSelector], (user = null) => {
  return user?.notifications || EMPTY_ARRAY;
});
